import React from 'react'
import { IProductInOrder } from 'product/IProduct'
import { Col, Row } from 'react-bootstrap'
import Image from 'components/Image'
import ProductDescription from 'product/ProductDescription'

interface IHistoryOrderProductListItemProps {
  product: IProductInOrder
}

const HistoryOrderProductListItem: React.FC<IHistoryOrderProductListItemProps> = ({
  product,
}) => {
  return (
    <Row className='border-b-full py-row-small'>
      {product.images && product.images.length > 0 ? (
        <>
          <Col xs={{ order: 2, span: 6 }} sm={{ order: 1, span: 4 }} md={3}>
            <Image
              url={
                product.images && product.images.length > 0 ? product.images[0].url : ''
              }
            />
          </Col>

          <Col xs={{ order: 1, span: 12 }} sm={{ order: 1, span: 4 }} md={6}>
            <div className='big-product-name-font' style={{ textAlign: 'left' }}>
              {product.name}
            </div>
          </Col>

          <Col xs={{ order: 2, span: 6 }} sm={{ order: 1, span: 4 }} md={3}>
            {product.refund_quantity ? (
              <div className='big-font' style={{ color: 'var(--color-red)' }}>
                Возврат {product.refund_quantity > 1 && <>{product.refund_quantity} x </>}
                {product.price}&nbsp;₽
              </div>
            ) : (
              <div className='big-font'>
                {product.quantity > 1 && <>{product.quantity} x </>}
                {product.price}&nbsp;₽
              </div>
            )}
          </Col>
        </>
      ) : (
        <>
          <Col xs={7} sm={8} md={9}>
            <div className='big-product-name-font' style={{ textAlign: 'left' }}>
              {product.name}
            </div>
          </Col>

          <Col xs={5} sm={4} md={3}>
            {product.refund_quantity ? (
              <div className='big-font' style={{ color: 'var(--color-red)' }}>
                Возврат {product.refund_quantity > 1 && <>{product.refund_quantity} x </>}
                {product.price}&nbsp;₽
              </div>
            ) : (
              <div className='big-font'>
                {product.quantity > 1 && <>{product.quantity} x </>}
                {product.price}&nbsp;₽
              </div>
            )}
          </Col>
        </>
      )}

      <ProductDescription product={product} showDescription='accordion' order={3} />
    </Row>
  )

  //   <Row style={style}>
  //     {product.images && product.images.length > 0 ? (
  //       <ProductItemHeaderWithImage product={product}>
  //         {children}
  //       </ProductItemHeaderWithImage>
  //     ) : (
  //       <ProductItemHeader product={product}>{children}</ProductItemHeader>
  //     )}

  //     <ProductDescription product={product} showDescription={showDescription} />

  //   </Row>
  // <Col xs={5} sm={4} md={3}>
  //   {product.refund_quantity ? (
  //     <h5 style={{ color: 'var(--color-red)' }}>Возврат {product.price}&nbsp;₽</h5>
  //   ) : (
  //     <h5>{product.price}&nbsp;₽ </h5>
  //   )}
  // </Col>
  // )
  // </Row>
}
export default HistoryOrderProductListItem
